import React from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";

import { ArrowRight } from "lucide-react";
import Header from "@/components/common/Header/header";
import BackgroundImage from "@/assets/images/landlord-background.png";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import BgGrid from "@/assets/images/bg-grid.png";
import ChargesCard from "@/assets/images/club_invite_fees.png";

export default function PlatformChargesScreen() {
  const navigate = useNavigate();

  return (
    <Div100vh
      className="flex flex-col justify-between items-center py-8 px-8"
      style={{
        backgroundImage: `url(${BgGrid}), url(${BackgroundImage})`,
        backgroundPosition: "top center, center center",
        backgroundSize: "100% 50%, cover",
        backgroundRepeat: "no-repeat, no-repeat",
      }}
    >
      <div className="w-full">
        <Header customBackSubmit={() => navigate("/benefits")} />
      </div>
      <img src={ChargesCard} alt="platform-charges" />
      <PrimaryButton
        text={"Verify Your details"}
        icon={ArrowRight}
        handleClick={() => navigate("/accept-invite")}
      />
    </Div100vh>
  );
}
